<template>
  <div class="application sharingincentives">
    <div v-for="item in data" :key="item.ID">
      <div v-if="item.status" class="sharingincentives__card">
        <div class="sharing-card__left">
          <p>{{ item.description }}</p>
        </div>
        <div class="sharing-card__right" @click="open(item)">
          <p>{{ $t('incentives.get') }}</p>
        </div>
      </div>
    </div>

    <!-- 分享弹窗 -->
    <el-dialog
      width="670px"
      :visible="visible"
      :show-close="true"
      :before-close="close"
      :lock-scroll="true"
      :append-to-body="true"
      custom-class="sharingincentives__dialog"
      :destroy-on-close="true"
    >
      <div class="sharing-dialog__body" v-if="current_item">
        <!-- 开始分享 -->
        <template v-if="!finishedShared">
          <p class="sharing-dialog__title">{{ current_item.description }}</p>
          <p class="sharing-dialog__text" v-if="type != 'free_shipping'">
            {{
              type == 'percent'
                ? $t('incentives.tip1', { coupon_amount: `${coupon_amount}%` })
                : $t('incentives.tip1', {
                    coupon_amount: `${priceSymbol}${computePrice(coupon_amount)}`,
                  })
            }}
          </p>
          <p class="sharing-dialog__text" v-else>{{ $t('incentives.freeshipping') }}</p>

          <template v-for="platform in sharingPlatform">
            <social-sharing
              :key="platform.key"
              :title="product_res.post_title"
              :description="product_res.post_title"
              :media="product_res.gallery.length ? product_res.gallery[0].url : 'null'"
              inline-template
              :url="`${url}&source=${platform}`"
              @open="share_event"
              @close="handleShared"
            >
              <network :network="platform.key">
                <div
                  class="sharing-dialog__item"
                  :style="{
                    backgroundColor: platform.primaryColor,
                  }"
                >
                  <p
                    :class="platform.icon"
                    :style="{
                      backgroundColor: platform.subColor,
                    }"
                  ></p>
                  <p>{{ platform.value }}</p>
                </div>
              </network>
            </social-sharing>
          </template>
          <p class="sharing-dialog__sub-text">{{ $t('incentives.tip2') }}</p>
        </template>

        <!-- 结束分享内容 -->
        <template v-else>
          <p class="sharing-dialog__title">{{ $t('incentives.congratulations') }}</p>

          <div class="sharing-dialog__discount">
            <p style="margin: 0" v-if="type != 'free_shipping'">
              {{
                type == 'percent'
                  ? $t('incentives.tip1', { coupon_amount: `${coupon_amount}%` })
                  : $t('incentives.tip1', { coupon_amount: `${priceSymbol}${computePrice(coupon_amount)}` })
              }}
            </p>
            <p style="margin: 0" v-else>{{ $t('incentives.freeshipping') }}</p>
          </div>

          <p class="sharing-dialog__sub-text">{{ $t('incentives.tip3') }}</p>
          <div class="sharing-dialog__code" @click="copy">{{ current_item.coupon.code }}</div>

          <div v-if="copyed" style="color: #2f2f2f; font-weight: 400; font-size: 14px">
            {{ $t('incentives.copysuccess') }}
          </div>
          <input :style="{ display: 'none' }" id="incentives_code" type="text" :value="current_item.coupon.code" />
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import API from '@/js/API'
import { mapState } from 'vuex'

export default {
  name: 'vSharingIncentives',
  props: {
    product_res: {
      type: Object,
      require: true
    },
    data: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      current_item: null,
      coupon_amount: 0,
      type: null,
      copyed: false, // 是否复制
      url: null,
      visible: false, // 分享弹窗
      finishedShared: false, // 完成分享
      // 分享平台
      sharingPlatform: [
        {
          key: 'facebook',
          value: 'Facebook',
          icon: 'iconfont icon-cm-icomoonfacebook',
          primaryColor: '#334e8a',
          subColor: '#3b5999',
        },
        {
          key: 'twitter',
          value: 'Twitter',
          icon: 'iconfont icon-cm-twitter',
          primaryColor: '#029ad8',
          subColor: '#05a0f5',
        },
        {
          key: 'pinterest',
          value: 'Pinterest',
          icon: 'iconfont icon-cm-_pinterest',
          primaryColor: '#b8181b',
          subColor: '#cc1f28',
        },
      ],
    }
  },
  methods: {
    // 复制文本
    copy() {
      document.getElementById('incentives_code').select()
      document.execCommand('Copy')
      this.copyed = true
    },

    // 打开弹窗
    open(e) {
      this.current_item = e

      let href = window.location.search ? window.location.href + '&' : window.location.href + '?'
      this.url = href + 'activity_mark=' + this.current_item.activity_mark

      const { discount_type, coupon_amount, free_shipping } = e.coupon

      if (free_shipping == 'no') {
        this.type = discount_type
        this.coupon_amount = coupon_amount
      } else {
        this.type = 'free_shipping'
        this.coupon_amount = 0
      }

      this.copyed = false
      this.visible = true
      this.finishedShared = false
    },

    // 关闭弹窗
    close() {
      this.visible = false
      this.finishedShared = false
      this.copyed = false
    },

    // 分享到社交
    share_event(e) {
      this.$('#sharingincentives').modal('hide')
      try {
        this.$axios.post(API.incentives_share, {
          source: e,
          activity_mark: this.current_item.activity_mark,
        })
      } catch (error) {
        console.log(error)
      }
    },

    // 关闭分享的弹窗
    handleShared() {
      // this.$('#sharediscount').modal('show')
      this.finishedShared = true
    },
  },
  computed: {
    ...mapState({
      // 用户选择的货币符号
      priceSymbol: ({ priceSymbol }) => priceSymbol,
    }),
  },
}
</script>

<style lang="scss" scoped>
.sharingincentives {
  position: relative;
  font-weight: bold;
  font-size: 16px;
  width: 348px;
  max-width: 400px;
  &__card {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    height: 62px;
    width: 100%;
    max-width: 100%;
    background-image: url('~@/images/applications/sharingIncentives/sharing.png');
    background-size: 100% 100%;
    background-position: left;
    background-repeat: no-repeat;
    color: #fff;
    font-size: 18px;
    p {
      line-height: 1;
      margin: 0;
    }
    .sharing-card {
      &__left {
        width: 62%;
        left: 0;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        p {
          line-height: 1.4;
        }
      }
      &__right {
        text-align: center;
        width: 38%;
        right: 0;
        cursor: pointer;
        padding: 15px 0;
        p {
          display: inline-block;
          border-radius: 20px;
          background: #fff;
          color: #ff5c28;
          font-weight: bold;
          padding: 6px 0px;
          margin: 0;
          width: 100px;
          height: 32px;
        }
        &:hover {
          p {
            background-color: #FAE4AC;
          }
        }
      }
    }
  }

  &__dialog {
    .sharing-dialog {
      // 标题
      &__title {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 12px;
        font-weight: bold;
      }
      // 文本
      &__text {
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 16px;
        font-weight: bold;
      }
      // 副文本
      &__sub-text {
        font-size: 14px;
        color: #898e88;
        font-weight: bold;
        line-height: 24px;
        word-break: break-word;
      }
      // 折扣
      &__discount {
        height: 270px;
        background-image: url('~@/images/applications/sharingIncentives/sharediscount.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        position: relative;
        & > p {
          position: absolute;
          bottom: 33%;
          left: calc(50% - 130px);
          color: #f26d66;
          font-size: 16px;
          font-weight: bold;
        }
      }
      // 优惠吗
      &__code {
        width: 60%;
        margin: 0 auto;
        border: 2px dashed #ffcc33;
        font-size: 16px;
        margin-bottom: 10px;
        cursor: pointer;
        padding: 6px 0;
      }
      &__body {
        &::v-deep {
          .sharing-dialog {
            &__item {
              width: 45%;
              height: 45px;
              margin: 0 auto 15px;
              cursor: pointer;
              display: flex;
              align-items: center;
              p {
                color: #fff;
                font-size: 20px;
                text-align: center;
                margin: 0;
                &:nth-child(1) {
                  width: 20%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
                &:nth-child(2) {
                  flex: 1;
                  font-weight: 400;
                }
              }
            }
          }
        }
      }
    }
  }

  // pad 适配
  @media screen and(max-width: 767px) {
    width: 100%;
    &__card {
      font-size: 16px;
    }
    &__dialog {
      .sharing-dialog {
        &__body {
          &::v-deep {
            .sharing-dialog {
              &__item {
                width: 50%;
              }
            }
          }
        }
        &__title {
          font-size: 24px;
        }
        &__text {
          font-size: 28px;
        }
        &__sub-text {
          font-size: 12px;
        }
      }
    }
  }

  // 移动端适配
  @media screen and(max-width: 576px) {
    &__dialog {
      .sharing-dialog {
        &__discount {
          height: 220px;
          & > p {
            left: calc(50% - 115px);
          }
        }
        &__code {
          width: 100%;
        }
        &__body {
          &::v-deep {
            .sharing-dialog {
              &__item {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang='scss'>
.sharingincentives {
  // 默认居中
  margin: 0 auto 10px;
  &__dialog {
    background-image: url('~@/images/applications/sharingIncentives/sharing1.jpg');
    background-repeat: repeat;
    border-radius: 15px;
    min-height: 450px;
    max-width: calc(100vw - 30px);
    margin-top: calc((100vh - 450px) / 2);
    text-align: center;
  }
}
</style>
